import React from 'react'

/**
 * Reusable component for multi select option
 * @param {*} props 
 * @returns 
 */
const MultiSelectOption = (props) => {
    const {data,isSelected,onSelected} = props;
    
    const handleClick = (e) => {
        e.stopPropagation()
        onSelected(data.name)
    }
    
  return (
    <div className='d-flex multi-select-option gap-2' onClick={handleClick}>
        <input type='checkbox' name={data.name} value={data.name} checked={isSelected} onChange={() => {}} />
        <span>{data.name}</span>
    </div>
  )
}

export default MultiSelectOption